import styled from 'styled-components';

const BASE_COLOR = '#BDBDBD';

export const NavItem = styled.div`
    width: ${props => props.dotSize || '12px'};
    height: ${props => props.dotSize || '12px'};
    border-radius: 50%;
    background: ${props => props.fill || BASE_COLOR};
    opacity: ${props => props.active ? '1' : '.5'};
    transition: all .5s ease-in-out;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
`;

export const NavList = styled.div`
    display: flex;
    flex-direction: ${props => !props.horizontal ? 'column' : 'row'};
    justify-content: space-around;
    height: 100%;
    width: 100%;
`;
